// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bc","header":"bd","title":"be","subTitle":"bf","profileList":"bh","profileListItem":"bi","warningMessage":"bj","manageProfileButton":"bk","withWarning":"bl"};